import { createBrowserHistory } from "history";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import getCoreHistoryStore from "./stores/core/core-history-store";
import getRootStore from "./stores/core/root-store";
import { ThemeProvider } from "./core/et3-theme";
import getTheme from "./core/et3-theme/getTheme";
import RouterComponent from "./routes";

const ThemedRouter = observer(() => {
  return (
    <ThemeProvider themeValue={getTheme().getThemeData.get()}>
      <RouterComponent />
    </ThemeProvider>
  );
});

const App = () => {
  const history = createBrowserHistory();
  useEffect(() => {
    getCoreHistoryStore().history.set(history);
    getRootStore().startApp();
    return () => {
      getRootStore().killAppTimersAndListenners();
    };
  }, [history]);

  useEffect(() => {
    if (window.top && window.top !== window.self) {
      window.top.location.href = window.location.href;
    }
  }, []);

  return <ThemedRouter />;
};
export default App;
